export const TYPING_DEBOUNCE_MS = 400;
export const PERSIST_DEBOUNCE_MS = 600;

export const EDGE_PAGE_DELAY_MS = 250;
export const EDGE_PAGE_REPEAT_MS = 600;
export const EDGE_PAGE_TICK_MS = 50;

export const HANDYOUT_FULL_STALE_MS = 120_000;
export const HANDYOUT_FULL_GC_MS = 15 * 60_000;
export const HANDYOUT_INTRO_STALE_MS = 300_000;
export const HANDYOUT_INTRO_GC_MS = 15 * 60_000;
export const MODULE_CHAT_HISTORY_STALE_MS = 5 * 60 * 1000;

export const SCROLL_DURATION_MS = 550;
export const VIEWER_SLIDE_CROSSFADE_MS = 240;
export const BOUNDARY_THROTTLE_MS = 150;
export const KEYBOARD_SETTLE_MS = 500;

export const HIDDEN_CLOSE_AFTER_MS = 5 * 60 * 1000;
export const VERIFY_TIMEOUT_MS = 20_000;

export const ANIMATED_ICON_REPEAT_DELAY_MS = 5000;
export const ANIMATED_ICON_MAX_RUN_MS = 2500;

export const INSIGHT_PANEL_ADVANCE_MS = 6000;
export const INSIGHT_PANEL_VISIBLE_AMOUNT = 0.5;
